import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { adminLogin } from "@/api/adminAuthApi"
import { useAdminAuth } from "@/contexts/AdminAuthContext"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"

export default function AdminLoginPage() {
    const navigate = useNavigate()
    const { refreshAdminAuth } = useAdminAuth()

    const [form, setForm] = useState({
        loginId: "",
        password: "",
    })

    const [loading, setLoading] = useState(false)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setForm((prev) => ({ ...prev, [name]: value }))
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()

        try {
            setLoading(true)
            const response = await adminLogin(form)

            if (response.success) {
                await refreshAdminAuth()
                alert("관리자 로그인 성공")
                navigate("/admin", { replace: true })
            } else {
                alert(response.message || "로그인에 실패했습니다.")
            }
        } catch (error) {
            console.error(error)
            alert("로그인 중 오류가 발생했습니다.")
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
            <div className="w-full max-w-md">
                <Card className="rounded-[28px] border border-slate-200 shadow-sm">
                    <CardContent className="p-8">
                        <div className="text-center">
                            <h1 className="text-3xl font-bold">관리자 로그인</h1>
                            <p className="mt-2 text-sm text-slate-500">
                                MG퀵플라워 관리자 페이지에 로그인하세요.
                            </p>
                        </div>

                        <form onSubmit={handleSubmit} className="mt-8 space-y-5">
                            <div className="space-y-2">
                                <Label htmlFor="loginId">아이디</Label>
                                <Input
                                    id="loginId"
                                    name="loginId"
                                    value={form.loginId}
                                    onChange={handleChange}
                                    placeholder="관리자 아이디"
                                    className="h-12 rounded-xl"
                                />
                            </div>

                            <div className="space-y-2">
                                <Label htmlFor="password">비밀번호</Label>
                                <Input
                                    id="password"
                                    name="password"
                                    type="password"
                                    value={form.password}
                                    onChange={handleChange}
                                    placeholder="비밀번호"
                                    className="h-12 rounded-xl"
                                />
                            </div>

                            <Button
                                type="submit"
                                disabled={loading}
                                className="h-12 w-full rounded-2xl bg-slate-900 hover:bg-slate-800"
                            >
                                {loading ? "로그인 중..." : "로그인"}
                            </Button>
                        </form>
                    </CardContent>
                </Card>
            </div>
        </div>
    )
}